.disclaimertext {
  margin: 0;
}
